<ng-template [ngIf]="!pane || !pane.loaded" [ngIfElse]="contentBlock">
  <div class="pane-mini">
    <loading-line height="40px" width="100%"></loading-line>
  </div>
</ng-template>

<ng-template #contentBlock>
  <div class="content-filters">
    <app-library-title [title]="blockTitle">
      <ng-container side>
        <div class="tab-filter">
          <ul class="tabs">
            <li class="tab normal"
                [class.active]="filterActive === eFilter.all"
                (click)="filterActive = eFilter.all">
              {{ 'library.content-filter.tab-all' | customLocale }}
            </li>
            <li class="tab normal"
                [class.active]="filterActive === eFilter.foreign"
                (click)="filterActive = eFilter.foreign">
              {{ 'library.content-filter.tab-foreign' | customLocale }}
            </li>
            <li class="tab normal"
                [class.active]="filterActive === eFilter.native"
                (click)="filterActive = eFilter.native">
              {{ 'library.content-filter.tab-native' | customLocale }}
            </li>
            <li class="tab normal"
                [class.active]="filterActive === eFilter.others"
                (click)="filterActive = eFilter.others">
              {{ 'library.content-filter.tab-others' | customLocale }}
            </li>
          </ul>
        </div>
      </ng-container>
    </app-library-title>

    <ng-template [ngIf]="isDragScrollEnabled && isBrowser && filterSubjects().length" [ngIfElse]="responsiveScroll">
      <div class="carousel">
        <ng-template [ngIf]="filterSubjects().length >= 5">
          <div class="right-btn" (click)="moveRight()">
            <app-icon class="right-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>

          <div class="left-btn" (click)="moveLeft()">
            <app-icon class="left-arrow" icon="drag-scroll-arrow"></app-icon>
          </div>
        </ng-template>

        <cdk-virtual-scroll-viewport #scroller
                                     [itemSize]="itemSize"
                                     class="scroll-viewport"
                                     orientation="horizontal">
          <div *cdkVirtualFor="let item of filterSubjects(); let i = index; trackBy: trackSubjectByFn"
               class="scroll-item">
            <app-subject-item [baseRoute]="baseRoute"
                              [link]="routeLinkByItem(item)"
                              [panel]="item"
                              (makeFavorite)="onMakeFavorite(item)">
            </app-subject-item>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>

    <ng-template #responsiveScroll>
      <div class="responsive-scroll-viewport">
        <div *ngFor="let item of filterSubjects(); let i = index; trackBy: trackSubjectByFn" class="scroll-item">
          <app-subject-item [baseRoute]="baseRoute"
                            [link]="routeLinkByItem(item)"
                            [panel]="item"
                            (makeFavorite)="onMakeFavorite(item)">
          </app-subject-item>
        </div>

        <ng-template [ngIf]="!filterSubjects().length">
          <div class="scroll-item">
            <ng-container *ngTemplateOutlet="stub_subject_item"></ng-container>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #stub_subject_item>
  <section class="stub-subject-item">
    <div class="icon-wrap">
      <app-icon width="32" height="30" icon="stub-subject-item"></app-icon>
    </div>
    <span class="text normal">{{ 'library.content-filter.stub-subject-text' | customLocale }}</span>
    <ng-template [ngIf]="isTeacher">
      <a routerLink="/constructor" class="create-lesson normal">{{ 'library.content-filter.create' | customLocale }}</a>
    </ng-template>
  </section>
</ng-template>

<pre *ngIf="false">{{ filterSubjects().length }} {{ filterSubjects() | json }}</pre>
